import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  selectCourseCategories,
  setCourseCategories,
} from 'src/mentor/reducers/courses/coursesReducer'
import { getMPData } from 'src/mentor/services'
import MentorHeader from '../MentorHeader'
import { HomePageContainer, HomePageItem } from '../MentorHomePage/MentorHomepageStyles'

export default function OnlineCourseRoles() {
  const navigate = useNavigate()
  const { courseCategory } = useParams()
  const [loading, setLoading] = useState(true)
  const categories = useSelector(selectCourseCategories)
  const dispatch = useDispatch()

  async function getCategories() {
    const resp = await getMPData('/api/secure/teacher/meta-categories')
    if (resp?.status === 200) {
      if (resp?.data) {
        const filteredMetaCategories = resp.data?.filter((item) => {
          return item?.categoryType === 'course'
        })
        dispatch(setCourseCategories(filteredMetaCategories))
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    getCategories()
  }, [])

  return (
    <>
      <MentorHeader
        heading={`Courses: ${
          categories?.find((cat) => {
            return cat?.id === courseCategory
          })?.title
        }`}
      />
      <HomePageContainer>
        <HomePageItem onClick={() => navigate('my-courses')}>My Courses</HomePageItem>
        <HomePageItem
        // onClick={() => navigate('my-courses')}
        >
          Approval Requests
        </HomePageItem>
      </HomePageContainer>
    </>
  )
}
